module.exports = __webpack_public_path__ + "img/BACOLOD.7008928f.jpg";